<template>
  <div id="app">
    <component :is="navComponentName" />

    <main class="content">
      <slot></slot>
    </main>

    <Footer></Footer>

    <div v-if="env == 'dev' || env == 'nstage'" class="snackbar">
      YOU ARE CURRENTLY IN A TESTING ENVIRONMENT.
      TO GO TO PRODUCTION, <a style="all: unset; color: black;" href="https://networks.resonancehealth.org/networks">CLICK HERE</a>
    </div>
  </div>
</template>
<script>
const Footer = () => import('./Footer.vue');
const Nav = () => import('@/views/layouts/nav/Nav.vue');
import { getNavComponentName, getBrandNavComponents } from '@/config/brands';
import { mapState } from 'vuex';

export default {
  name: 'DefaultLayout',
  components: {
    Footer,
    Nav,
    // Dynamically register all brand nav components from the registry
    ...getBrandNavComponents(),
  },
  data() {
    return {
      env: process.env.VUE_APP_ENV,
    };
  },
  computed: {
    ...mapState({
      maintenance: (state) => state.maintenance,
      currentBrand: (state) => state.currentBrand,
    }),
    navComponentName() {
      return getNavComponentName(this.currentBrand) || 'Nav';
    },
  },
};
</script>
<style scoped>
.content {
  min-height: 80vh;
}
.snackbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgb(15 77 139 / 80%);
  color: #fff;
  text-align: center;
  padding: 10px;
  z-index: 1000;
  font-size: 18px;
  font-weight: 600;
}
</style>
